import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TextFieldModule } from '@angular/cdk/text-field';
import { OverlayModule } from '@angular/cdk/overlay';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MatProgressBarModule,
		MatTooltipModule,
		MatListModule,
		MatCheckboxModule,
		MatTableModule,
		MatProgressSpinnerModule,
		MatGridListModule,
		MatDialogModule,
		MatIconModule,
		MatSelectModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatChipsModule,
		MatCardModule,
		MatDividerModule,
		MatFormFieldModule,
		MatButtonModule,
		MatSidenavModule,
		MatSortModule,
		DragDropModule,
		TextFieldModule,
		OverlayModule,
		MatTabsModule,
		MatRippleModule,
	],
	exports: [
		MatProgressBarModule,
		MatTooltipModule,
		MatListModule,
		MatCheckboxModule,
		MatTableModule,
		MatProgressSpinnerModule,
		MatGridListModule,
		MatDialogModule,
		MatIconModule,
		MatSelectModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatChipsModule,
		MatCardModule,
		MatDividerModule,
		MatFormFieldModule,
		MatButtonModule,
		MatSidenavModule,
		MatSortModule,
		DragDropModule,
		TextFieldModule,
		OverlayModule,
		MatTabsModule,
		MatRippleModule,
	],
})
export class MaterialModule {}
